








































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import BaseTable, { TableDataRow } from "@/components/BaseTable.vue";
import TableModal from "@/components/TableModal.vue";
import BorderedButton from "@/components/BorderedButton.vue";
import { CategorySelectorRow } from "@/services/CategoriesDataService";
import { isSubcategory } from "@/helpers/CategoryHelpers";
@Component({
  components: { BorderedButton, TableModal, BaseTable }
})
export default class ExpandingTable extends Vue {
  @Prop({ default: "" }) private title!: string;
  @Prop({ default: [] }) private data!: TableDataRow[];
  @Prop({ default: "" }) private filterName!: string;
  @Prop() private selectTo?: string;
  @Prop() private selectCallback?: any;
  @Prop() private maxRows?: number;
  @Prop() private filter?: any;
  @Prop() private category!: CategorySelectorRow | null;

  private tableData: TableDataRow[] = [];
  private tableTitle = "";
  private isFiltering = false;
  private isModalVisible = false;

  @Watch("data")
  onPropertyChanged(value: TableDataRow[], oldValue: TableDataRow[]) {
    this.setTableData();
  }

  mounted() {
    this.setTableData();
  }

  private setTableData() {
    this.tableData = this.data.slice(
      0,
      this.maxRows ? this.maxRows : this.data.length
    );
    this.tableTitle = `${this.title} (Total: ${this.data.length})`;
  }

  private onSelect(item: any) {
    if (this.selectTo) {
      const selected = { ...item };
      if (isSubcategory(selected)) {
        selected.id = selected.id.replace(`${selected.parentId}-`, "");
      }

      this.$router.push({
        name: this.selectTo,
        query: { payload: JSON.stringify({ ids: [selected] }) }
      });
    }

    if (this.selectCallback) {
      const selected = { ...item };
      if (isSubcategory(selected)) {
        selected.id = selected.id.replace(`${selected.parentId}-`, "");
      }

      this.selectCallback(selected);
    }
  }

  get filterButtonName() {
    return this.isFiltering
      ? `Show ${this.filterName}`
      : `Hide ${this.filterName}`;
  }

  private toggleFilter() {
    if (this.filter) {
      if (this.isFiltering) {
        // Stop filtering
        this.tableData = this.data.slice(
          0,
          this.maxRows ? this.maxRows : this.data.length
        );
        this.tableTitle = `${this.title} (Total: ${this.data.length})`;
      } else {
        // Start filtering
        const newData = this.data.filter(this.filter);
        this.tableTitle = `${this.title} (Total: ${newData.length})`;
        this.tableData = newData.slice(
          0,
          this.maxRows ? this.maxRows : newData.length
        );
      }
      this.isFiltering = !this.isFiltering;
      this.$forceUpdate();
    }
  }

  private expand() {
    this.isModalVisible = true;
    this.$forceUpdate();
  }

  private closeModal() {
    this.isModalVisible = false;
  }
}
